import React, { useEffect } from 'react';
import "../../Styles/About.css";

const About = () => {
  useEffect(() => {
    // Add animation triggers when component mounts
    const elements = document.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right, .scale-in');
    elements.forEach(el => {
      el.style.opacity = '1';
      el.style.transform = 'translateX(0) scale(1)';
    });
  }, []);

  return (
    <div className="about-container">
      <div className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="fade-in">Our Story</h1>
          <p className="fade-in">Where Passion Meets Performance</p>
        </div>
      </div>

      <div className="content-section">
        <div className="section about-intro">
          <div className="text-content slide-in-left">
            <h2 className="About-name">About Us: <span className="brand-name">Shield-X Sports</span></h2>
            <p>At Shield-X Sports, we understand the value of standing out on the field, track, or court. The journey that led us here started with a simple frustration: we wanted a jersey that was as unique as our passion for sports.</p>
            <p>But time and again, we couldn't find one that truly represented us – one that fit our style and performance needs perfectly. That's when we realized: if we couldn't find the perfect customized jersey, maybe others couldn't either.</p>
          </div>
          <div className="image-content slide-in-right">
            <div className="image-placeholder"></div>
          </div>
        </div>

        <div className="section our-vision">
          <div className="image-content slide-in-left">
            <div className="image-placeholder"></div>
          </div>
          <div className="text-content slide-in-right">
            <h2 className="About-name">Our Vision</h2>
            <p>We came up with the idea of Shield x Sports when we had the vision to create a brand that delivers high-quality customized jerseys for athletes, sports teams, and enthusiasts. From football t-shirts in the USA to custom sportswear in the USA, we have covered it all while also providing the possibility of personalising each item to your liking.</p>
            <p>Our team is not just a bunch of professionals who are into sports, like in another company, but a bunch of professionals who love sports because they know the need for style and performance.</p>
          </div>
        </div>

        <div className="section commitment">
          <div className="text-content slide-in-left">
            <h2 className="About-name">Our Commitment</h2>
            <p>Right from the start, we have been unwavering in our commitment to the use of high-quality materials as a mark of quality and the comfort, sustainability, and functionality of every piece—custom shirt design World Cup fan gear USA, where anyone can have the jersey they want.</p>
            <p>We have a variety of custom sports jerseys, custom t-shirts in bulk USA, and bulk sports clothes that you can choose from to show what you stand for.</p>
          </div>
          <div className="image-content slide-in-right">
            <div className="image-placeholder"></div>
          </div>
        </div>
 <div className="content-section">
        <div className="manufacturing-section fade-in">
          <div className="manufacturing-content">
            <h2 className="About-name">Our Commitment to Excellence</h2>
            <p>With fully owned manufacturing units in the USA and a reputation for excellence, Shield x Sports is your go-to destination for buying sports t-shirts online, cricket t-shirts USA, and football fan shirts that stand out.</p>
            
          </div>
        </div>
        </div>
        <p className="tagline" style={{fontWeight:"bold"}}>Wear your passion. Wear your Shield.</p>
        <div className="mission-values">
          <div className="mission scale-in">
            <h3>Mission</h3>
            <p>To empower athletes and sports enthusiasts by providing premium, customizable sports apparel that enhances performance and represents individuality.</p>
          </div>
           <div className="values scale-in">
            <h3>Vision</h3>
            <p>To be the leading provider of customized sportswear in the USA, offering innovative and top-notch products that inspire athletes to perform at their best.</p>
          </div>
          <div className="values scale-in">
            <h3>Values</h3>
            <ul>
              <li><span className="value-name">Quality:</span> We are committed to delivering the highest standard of sports apparel, built to last and perform.</li>
              <li><span className="value-name">Customer-Centricity:</span> We prioritize our customers' needs, providing tailor-made solutions to match their unique style and requirements.</li>
            </ul>
          </div>
        </div>

        
      </div>
    </div>
  );
};

export default About;